<script>
// Render empty for empty slots
export default {
    name: 'VEmpty',
    render(h) {
        return h();
    }
};
</script>
